import React, { createContext, useContext, useEffect, useState } from 'react';
import { setAuthContext, setGetAccessToken } from '../api';

const TOKEN_KEY = 'access_token';

export const AuthContext = createContext<{
  accessToken: string | null;
  setAccessToken: (token: string | null) => void;
}>({
  accessToken: null,
  setAccessToken: () => {}
});

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [accessToken, setAccessTokenState] = useState<string | null>(() => {
    // Initialize from localStorage
    return localStorage.getItem(TOKEN_KEY);
  });

  // Custom setter that updates both state and localStorage
  const setAccessToken = (token: string | null) => {
    setAccessTokenState(token);
    if (token) {
      localStorage.setItem(TOKEN_KEY, token);
    } else {
      localStorage.removeItem(TOKEN_KEY);
    }
  };

  // Set up the token setter and getter for the API interceptor
  useEffect(() => {
    setAuthContext(setAccessToken);
    setGetAccessToken(() => accessToken);
    return () => {
      setAuthContext(() => {});
      setGetAccessToken(() => null);
    };
  }, [accessToken]); // Re-run when accessToken changes

  return (
    <AuthContext.Provider value={{ accessToken, setAccessToken }}>
      {children}
    </AuthContext.Provider>
  );
}